<template>
  <div>
    <div class="ldmeet-nav">
      <div class="dsxxpage-tit">历次党代会</div>
      <el-menu
        :default-active="defaultActive"
        :default-openeds="defaultOpeneds"
        @open="handleOpen"
        class="el-menu-vertical-demo"
        router
        :unique-opened="true"
      >
        <el-submenu
          v-for="(item, i) in menuList"
          :key="i"
          :index="i.toString()"
        >
          <template slot="title">
            <span>{{ item }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-if="i > 3" :index="`/LidaiParty/MeetDetail${20-i}`"
              >大会简介</el-menu-item
            >
            <el-menu-item :index="`/LidaiParty/BgqwPage${20-i}`" v-if="i < 9"
              >报告全文</el-menu-item
            >
            <el-menu-item :index="`/LidaiParty/Literature/${i}/${menuList[i]}`"
              >文献研究</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template> 
     <script>
export default {
  data() {
    return {
      defaultActive: "/LidaiParty/BgqwPage20",
      defaultOpeneds: ["0"],
      menuList: ["二十大","十九大","十八大","十七大","十六大","十五大","十四大","十三大","十二大","十一大","十大","九大","八大","七大","六大","五大","四大","三大","二大", "一大"],
    };
  },
  watch: {
    $route: {
      handler(newVal) {
        this.defaultActive = newVal.path;
      },
      deep: true,
    },
  },
  mounted() {
    const { path } = this.$route;
    this.defaultActive = path;
  },
  methods: {
    handleOpen(key, keyPath) {
      this.$router.push(key > 3 ? `/LidaiParty/MeetDetail${20-key}` : `/LidaiParty/BgqwPage${20-key}`);
      this.defaultOpeneds = [`${key}`];
    },
  },
};
</script>
<style lang="scss" scoped>
.ldmeet-content {
  width: 1200px;
  height: 800px;
  margin: 30px auto;
  background-color: antiquewhite;
  .ldmeet-nav {
    position: relative;
    //    margin-top:20px;
    width: 220px;
    height: auto;
    box-sizing: border-box;
    padding: 60px 14px 10px 14px;
    background: #fff8f8;
    border: 1px solid #fae0e0;
    .dsxxpage-tit {
      position: absolute;
      z-index: 10;
      top: 0;
      left: -7px;
      width: 232px;
      height: 51px;
      text-align: center;
      line-height: 51px;
      font-size: 18px;
      color: #f9fdcc;
      //    background: url('../assets/images/dsxxpage-tit.png') no-repeat;
      background: url("../../../assets/images/dsxxpage-tit.png") no-repeat;
    }
     ::v-deep.el-menu {
      width: 200px !important;
      background: none !important;
      border: none;
    }
     ::v-deep.el-menu-item {
      margin-top: 10px;
      width: 192px;
      height: 40px;
      color: #383636 !important;
      line-height: 40px;
      //  background-color: #FAE0E0 !important;
    }
     ::v-deep.el-menu-item:hover {
      background: url("../../../assets/images/dmeet-nav.png") no-repeat;
    }
     ::v-deep.el-submenu__title {
      width: 192px;
      height: 40px;
      color: #ffffff;
      line-height: 40px;
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      //  background-color: #FAE0E0 !important;
      background: url("../../../assets/images/dmeet-nav.png") no-repeat;
      i{
        color: #fff;
      }
    }
     ::v-deep.el-submenu__title:hover {
      background: url("../../../assets/images/dmeet-nav.png") no-repeat;
    }

     ::v-deep.el-submenu .el-menu-item {
      width: 192px !important;
      min-width: 192px !important;
      text-align: left;
      background: #fff0f0;
    }
     ::v-deep.el-menu-item-group__title {
      padding: 0 !important;
    }
     ::v-deep.is-active {
      color: #b40808 !important;
      // background: #FF9142 !important;
      //    background:url('../assets/images/dmeet-nav.png') no-repeat !important;
    }
  }
}
</style>